import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useSelector, uninitState, statusLoading, statusSuccess } from '@grandvisionhq/state';
import { getAuth, getUserData } from '../selectors.js';
import { getLoggedInState, isLoggedIn } from '../state.js';
import 'lodash/isEmpty';
import { getParsedDataFromLS, writeUserDataToLS } from '../Util/customer-name-persistor.js';
import 'history';
import '@grandvisionhq/graphql';
import '../types.js';
import { MyAccountMenu } from './MyAccountMenu.js';

const MyAccountMenuContainer = (props)=>{
    const auth = useSelector(getAuth);
    const userData = useSelector(getUserData) || uninitState();
    const [viewState, setViewState] = React.useState('loading');
    const [personalDetails, setPersonalDetails] = React.useState(getParsedDataFromLS);
    React.useEffect(()=>{
        const isAuthLoading = getLoggedInState(auth) === 'loading';
        if (isAuthLoading || statusLoading(userData)) {
            setViewState('loading');
        // If the user is logged in or if there are personal details in local storage.
        } else if (isLoggedIn(auth) || !!personalDetails) {
            setViewState('known-user');
            if (statusSuccess(userData)) {
                setPersonalDetails(userData.result.personalDetails);
                //todo: move this to a saga
                writeUserDataToLS(userData.result.personalDetails);
            }
        } else {
            setViewState('unknown-user');
        }
    }, [
        auth,
        userData
    ]);
    return /*#__PURE__*/ React.createElement(MyAccountMenu, swcHelpers.extends({}, props, {
        viewState: viewState,
        personalDetails: personalDetails
    }));
};

export { MyAccountMenuContainer };
//# sourceMappingURL=MyAccountMenuContainer.js.map
